<template>
  <div :key="index" class="school-page_wrapper">
    <cmps-sidebar></cmps-sidebar>
    <main class="card-container" role="main" aria-label="'Schools search results">
      <div class="tags-container">
        <div class="sr-only" tabindex="-1" aria-live="polite" aria-atomic="true" id="card-search-results">{{ ariaText }}</div>
        <div class="field is-grouped is-grouped-multiline">
          <div class="control mw-100">
            <cmps-tag :type="'results'" :count="filteredSchools.results"></cmps-tag>
          </div>
          <div class="control mw-100" v-show="addressSort.active">
            <cmps-tag :type="'address'" :address="addressSort.address"></cmps-tag>
          </div>
          <div class="control mw-100" v-show="gradeLevel">
            <cmps-tag :type="'gradeLevel'" :title="gradeLevel"></cmps-tag>
          </div>
          <div class="control mw-100" v-for="feature in selectedFeatures" :key="feature.id">
            <cmps-tag :type="'feature'" :title="feature"></cmps-tag>
          </div>
        </div>
      </div>

      <div class="card-grid" v-if="filteredSchools.results">
        <p v-if="gradeLevel === 'Preschool'">
          <a href="http://www.mpsaz.org/kinderu" target="_blank">KinderU</a> is Mesa Public School's Preschool Program and is offered at the schools listed below.
        </p>
        <p v-if="gradeLevel === 'Choice School'">
          Choice Schools are schools within the district that have unique application processes and usually require students to have strong academic and disciplinary records. Read our <a href="#">FAQ</a> for more information.
        </p>
        <cmps-card v-for="school in filteredSchools.normal" :key="school.id" :school="school"></cmps-card>
        <h1 v-if="filteredSchools.choice.length && gradeLevel !== 'Choice School'">Choice Schools</h1>
        <cmps-card v-for="school in filteredSchools.choice" :key="school.id" :school="school"></cmps-card>
      </div>
      <div v-if="this.loading.active && !this.timeout.active" class="text-center my-5 py-5 is-size-4 is-size-2-desktop">
        <h1>Loading...
          <i class="fas fa-spinner fa-spin"></i>
        </h1>
      </div>
      <div v-if="this.timeout.active && this.loading.active" class="text-center my-5 py-5 is-size-4 is-size-2-desktop">
        <h1 style="color: #990022;">
          No response from API.
          <br />Please contact MPS Web Services at
          <br />
          <a style="color: #112266" href="mailto:web@mpsaz.org">web@mpsaz.org</a>
          &nbsp;<i style="color: #FFCC33" class="fas fa-envelope"></i>
        </h1>
    </div>

    </main>
    <cmps-tooltip></cmps-tooltip>
  </div>
</template>

<script>
  import Sidebar from '@/components/filters/Sidebar.vue'
  import Card from '@/components/Card.vue'
  import Tooltip from '@/components/Tooltip.vue'
  import Tag from '@/components/Tag.vue'
  import { mapMutations } from 'vuex';

  export default {
  	components: {
      cmpsCard: Card,
      cmpsSidebar: Sidebar,
      cmpsTooltip: Tooltip,
      cmpsTag: Tag
    },

    data() {
      return {
        index: 0
      }
    },

    methods: {
      ...mapMutations([
        'toggleTimeout'
      ]),
      forceUpdate() {
        this.index++
      },
      handleLanguage() {
        if (this.language.current !== 'en') {
          this.forceUpdate();
        }
      },
    },

    computed: {
      loading() { return this.$store.state.main.loading },
      language() { return this.$store.state.main.language },
      selectedFeatures() { return this.$store.getters.selectedFeatures },
      gradeLevel() { return this.$store.getters.formattedGradeLevel },
      filteredSchools() { return this.$store.state.main.filteredSchools },
      ariaText() { return this.$store.getters.ariaData.description },
      addressSort() { return this.$store.getters.addressSort },
      timeout() { return this.$store.state.main.timeout },
    },

    created() {
      const timeout = setTimeout(() => {
        this.toggleTimeout(true);
      }, 20000)

      if (!this.loading.active) {
        this.toggleTimeout(false)
        clearTimeout(timeout)
      }
    },

    beforeUpdate() {
      this.handleLanguage();
    },
  }
</script>


<style lang="scss" scoped>
  .school-page_wrapper {
    margin-top: 50px;
    display: flex;
    align-items: flex-start;
    position: relative;
  }
  .card-container {
    width: 304px;
    margin: 1rem auto;
    // scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    @media screen and (min-width: 400px) { //when 1 card(360px width + 24px margins) will fit on screen
      width: 384px;
    }
    @media screen and (min-width: 768px) { //when 2 cards(360px width + 24px margins) will fit on screen
      width: 768px;
    }
    @media screen and (min-width: 1024px) { //when 3 cards(315px width + 20px margins) will fit on screen
      width: 1005px;
    }
    @media screen and (min-width: 1216px) { //when 3 cards(281px width + 16px margins) will fit on screen, this is also when sidebar appears on screen
      width: 891px;
    }
    @media screen and (min-width: 1408px) { //when 3 cards(315px width + 24px margins) will fit on screen
      width: 1017px;
    }
    @media screen and (min-width: 1600px) { //when 3 cards(360px width + 24px margins) will fit on screen
      width: 1152px;
    }
    @media screen and (min-width: 1803px) { //when 4 cards(328px width + 24px margins) will fit on screen
      width: 1408px;
    }
    @media screen and (min-width: 1931px) { //when 4 cards(360px width + 24px margins) will fit on screen
      width: 1536px;
    }
    @media screen and (min-width: 2315px) { //when 5 cards(360px width + 24px margins) will fit on screen
      width: 1920px;
    }
    @media screen and (min-width: 2699px) { //when 6 cards(360px width + 24px margins) will fit on screen
      width: 2304px;
    }
    @media screen and (min-width: 3083px) { //when 7 cards(360px width + 24px margins) will fit on screen
      width: 2688px;
    }
  }
  .card-grid > h1 {
    font-size: 2.5rem;
    font-weight: 600;
    font-family: 'Montserrat', sans-serif;
    margin: 50px 15px 15px 15px;
    border-bottom: 1px solid #000;
  }
  .card-grid > p {
    font-size: 1.25rem;
    font-weight: 500;
    font-family: 'Roboto', sans-serif;
    margin: 15px;
  }
  .tags-container {
    margin: auto 12px 15px 12px;
  }

</style>
